var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"id":_vm.cb.name,"value":"done","unchecked-value":"todo","switch":"","disabled":!_vm.canComplete},on:{"change":function($event){return _vm.toggle()}},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }